export default {
	products(state) {
		return state.products
	},
}
